module.exports = __webpack_public_path__ + "assets/img/pan1.456f43d4.svg";